import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const CloseIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="0 0 24 24">
		<path
			fill="none"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
		/>

		<g opacity={0.4}>
			<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M9.16992 14.8299L14.8299 9.16992" />
			<path fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="M14.8299 14.8299L9.16992 9.16992" />
		</g>
	</SvgIcon>
)

export default CloseIconAtom
